module.exports = __webpack_public_path__ + "img/back.00b12d57.png";